
import { ReactNode } from "react";

import HeaderDetail from "../organisms/HeaderDetail";
import Footer from "../organisms/Footer";

type LayoutProps = {
  children: ReactNode;
};

export default function MainLayoutDetail({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <HeaderDetail />
      <main className="flex-grow">{children}</main>
      <Footer/>
    </div>
  );
}
